import { getEmailFromSearch } from '../../../utils/emailFromQuery'

// The signup form's initial values. The email comes from ?email= on the welcome-email link
// and stays editable.
export const getSignupDefaults = (search = '') => ({
	firstName: '',
	lastName: '',
	email: getEmailFromSearch(search),
	password: '',
})

export default getSignupDefaults
